import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MetricActionType, MetricModule, MetricType, Metrics } from '../models/metrics';
import { StockProductListResponse, StockProductSearchCriteria } from '../models/stock-transfer-request.model';
import { BaseService } from './base.service';

@Injectable()
export class StockProductService extends BaseService {
  public headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.stockProduct;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  public searchByCriteria(criteria: StockProductSearchCriteria): Observable<StockProductListResponse> {
    const metricsReq: Metrics = {
      metrics: [
        {
          metricType: MetricType.RESPONSE_TIME,
          module: MetricModule.STOCK_PRODUCT,
          route: this.envService.url,
          action: MetricActionType.SEARCH
        }
      ]
    };
    const params = this.getParams(criteria, true);

    return this.http.get<StockProductListResponse>(this.getUrl(), {
      headers: this.loaderHeaders(null, metricsReq),
      observe: 'body',
      params
    });
  }
}
